import { render } from "./List.vue?vue&type=template&id=5973d154&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=5973d154&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5973d154"

export default script